import { useTranslation } from 'react-i18next';
import '../styles/QuizResultModal.css';

export default function QuizResultModal({ isOpen, onClose, onReturnToMap, isCorrect }) {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const handleOverlayClick = (e) => { if (e.target === e.currentTarget) onClose(); };
  const handleButtonClick = () => { isCorrect ? onReturnToMap() : onClose(); };

  // 差し替え画像
  const ICON_SRC = isCorrect
    ? '/images/stamp/stamp.svg'
    : '/images/stamp/not_stamp.svg';

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className={`quiz-result-modal ${isCorrect ? 'correct' : 'incorrect'}`}>
        {isCorrect && <div className="confetti-background">{/* 紙吹雪 */}</div>}
        <div className="result-content">
          <h2 className="result-title">
            {isCorrect ? t('quiz.correct') : t('quiz.incorrect')}
          </h2>
          <div className="result-icon">
            <img
              src={ICON_SRC}
              alt={isCorrect ? '正解' : '不正解'}
              className="result-img"
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
          </div>
          <button className="result-button" onClick={handleButtonClick}>
            {isCorrect ? t('quiz.backToMap') : t('quiz.backToQuiz')}
          </button>
        </div>
      </div>
    </div>
  );
}
